// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// WARNING - Values under "firebase" and value of "googleApiKey" needs to be replaced from your own accounts
// If left as is, it firbase and google map related functionality will not work on LIVE instance.
export const environment = {
  production: false,

  APP_KEY: '71ae472a-3fbd-47af-af0e-30ade6b74892',
  SchoolNo: 'DEMO',

  // APP_KEY: "991050df-a3aa-4899-9086-def615e1d4ec",
  // SchoolNo: "NTS",

  // APP_KEY: '43cf33b8-8fa0-4497-99bc-d33f9bf53f79',
  // SchoolNo: 'KPS',

  // APP_KEY: '3fd4b681-675d-44cb-9a88-ab570ad1ec59',
  // SchoolNo: 'PHK',

  // APP_KEY: '98ee52d9-a6eb-4826-99dd-16b89f9c0424',
  // SchoolNo: 'SUKUM',   

  lang: "lang",
  apiUrl: "https://gov-service.misschool.net/v1",
  apiUrlGo: 'https://seashell-app-oqvat.ondigitalocean.app/service2/api/v2',
  fileUrl: "http://localhost:8000",

  permission: "permission",
  currentUser: "currentUser",
  SchoolInFo: "SchoolInfo",
  firebase: {
    apiKey: "AIzaSyBRsIA-uJ1uww_d8vMj4-n5izohYBLwO_k",
    authDomain: "edu-gov.firebaseapp.com",
    projectId: "edu-gov",
    storageBucket: "edu-gov.appspot.com",
    messagingSenderId: "110309746768",
    appId: "1:110309746768:web:b48fcb5cfa8298bc76c955",
    measurementId: "G-0FZR81GPC1",
  },
  googleApiKey: "AIzaSyAIIYOxA7qeetFz6TuR1Qewc0Rrjhzx7ZU",
  zoom: {
    clientID: "bPpVK6mhQeeABUP6wjxcGw",
    clientSecret: "wUw3TUrYaywcQ6XOJqtXcULbGf98L6Un",
    redirect: "http://localhost:9000/api/zoom/auth",
    apiKey: "KukJIy7PQCqeSq8stV6lMg",
    leaveUrl: "http://localhost:4300/system/user/profile",
  },
  pusher: {
    app_id: "1167381",
    key: "792bb66716cb34af4453",
    secret: "d7dfd5b62559359be838",
    cluster: "ap1",
    chanel: "scan-monitor",
    event: "monitor",
  },
};
